export default function tableToolHistory(HelperTable) {

    const selectorTable = '#table-tool-history';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const columns = [
        {data: 'id', label: 'ID', orderable: true,},
        {data: 'to_user_name', label: 'Deținător', orderable: false},
        {data: 'from_user_name', label: 'Preluat de la', orderable: false},
        {
            data: null, defaultContent: '', name: 'poze', label: 'Poze', orderable: false, searchable: false,
            render: (data, type, row) => {

                if (type === 'display') {
                    let html = '<div style="display: flex; align-items: center;  gap: 5px;">';
                    row.s3_img_urls.forEach((url) => {
                        html += `<a href="${url}" target="_blank">
                                    <img src="${url}" alt="poza" style="width: 35px; height: 35px; object-fit: cover;">
                                 </a>`;
                    });
                    html += '</div>';

                    return html;
                }

                return data;
            }
        },
        {data: 'created_at', name: 'created_at', label: 'Creat La'},
    ];


    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        stateSave: false,
        displayLength: 20,
        order: [
            [0, 'dsc']
        ],
        processing: false,
        serverSide: false,
        info: false,
        layout: {

            topStart: {
                buttons: [HelperTable.btnDownloads()],
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        }
    });

}